module.exports = __webpack_public_path__ + "img/banner-06.f73f3dc4.jpg";